import React from 'react';
import { Grid } from 'framework-ui-components';
import InputRicerca from './InputRicerca';
import AzioniAssegnoNucleoFamiliare from './AzioniAssegnoNucleoFamiliare';

const BarraAzioni = ({ ricercaSemplice, avviaRicerca, ...azioni }) => (
  <Grid.Row>
    <Grid.Col md="5">
      <InputRicerca {...ricercaSemplice} onClickCerca={(termine) => avviaRicerca({ termine })} />
    </Grid.Col>
    <Grid.Col md="7">
      <AzioniAssegnoNucleoFamiliare {...azioni} />
    </Grid.Col>
  </Grid.Row>
);

export default BarraAzioni;
